import React, { ReactNode } from "react";

interface IIEItemsWrapper {
    children: ReactNode;
}

export const IEItemsWrapper = (props: IIEItemsWrapper) => {
    return <div>{props.children}</div>;
};
